import React, { useRef } from "react";
import "./potChargesModal.scss";
import { Icons } from "../../atoms/Icons";
import { Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Buttons from "../../atoms/Buttons";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import generatePDF from "react-to-pdf";
import { potCharges } from "../../redux/constants";
import { calculateVintage, findFunds, openPopup } from "../../helpers/helpers";
import LabelText from "../../atoms/LabelText";
import { popupBlockerText } from "../../constants/constants";

const PotChargesModal = (props) => {
  const { retirementYear, investmentFunds, birthYear } = props;
  const savingsDrawdown = props?.data?.items?.filter(
    (elem) =>
      elem?.content?.properties?.fundUse === potCharges.SavingsAndDrawdown, // eslint-disable-line
  );

  const managedForYouAll = savingsDrawdown.filter(
    (elem) =>
      elem?.content?.properties?.investmentStyle === potCharges.ManagedForYou, // eslint-disable-line
  );
  const selfManagedAll = savingsDrawdown.filter(
    (elem) =>
      elem?.content?.properties?.investmentStyle === potCharges.SelfManaged, // eslint-disable-line
  );
  const selfManaged = selfManagedAll?.reduce((accumulator, current) => {
    if (
      !accumulator.find(
        (item) =>
          item?.content?.properties?.fundName ===
            current?.content?.properties?.fundName &&
          item?.content?.properties?.fundCharge ===
            current?.content?.properties?.fundCharge, //eslint-disable-line
      )
    ) {
      accumulator.push(current);
    }
    return accumulator;
  }, []);
  const bYear = new Date(birthYear)?.getFullYear();
  const vintageYear = calculateVintage(bYear);
  const filterDrawdownFunds = findFunds(
    props.data?.items,
    vintageYear.age75Year,
    vintageYear.age95Year,
  );
  const drawdownFunds = filterDrawdownFunds?.filter(
    (fund) => fund.fundName !== "Annuity Aware Fund",
  );
  const GP3Fund = props?.data?.items?.filter(
    (elem) =>
      elem?.content?.properties?.fundReference?.toLowerCase() === "gp3 fund fact sheet".toLowerCase() // eslint-disable-line
  );
  function checkIfPre99FundExists() {
    let isPre99 = false;
    investmentFunds?.map((investmentFundItem) => {
      if (investmentFundItem?.fundName.includes("Pre 1999")) {
        isPre99 = true;
      }
    });
    return isPre99;
  }
  const managedForYou = managedForYouAll.filter((fundItem) => {
    if (
      (fundItem?.content?.properties?.fundFrom <= retirementYear &&
        retirementYear <= fundItem?.content?.properties?.fundTo) ||
      fundItem?.content?.properties?.fundFrom == null ||
      fundItem?.content?.properties?.fundTo == null
    ) {
      // Checking if Pre 1999 fund exist, then checking if member is invested
      // in that, if not exist in investmen then removing it.
      if (fundItem?.content?.properties?.fundName?.includes("Pre 1999")) {
        const mFundName = fundItem?.content?.properties?.fundName;
        const mIsPre99Exist = investmentFunds?.find((investmentFundItem) => {
          return investmentFundItem?.fundName == mFundName;
        });

        if (!mIsPre99Exist) {
          return fundItem?.content?.properties?.fundName != mFundName;
        } else {
          return fundItem;
        }
      }
      return fundItem;
    }
  });

  const targetRef = useRef();
  const fundTooltips = (
    <Popover id="popover-contained" className="tooltip-popover-section">
      <Popover.Body className="tooltip-popover-body">
        Click on a fund name to view a fund factsheet.
      </Popover.Body>
    </Popover>
  );
  const fundManagementTooltips = (
    <Popover id="popover-contained" className="tooltip-popover-section">
      <Popover.Body className="tooltip-popover-body">
        Included in the daily value of the fund.
      </Popover.Body>
    </Popover>
  );
  const administrationChargeTooltips = (
    <Popover id="popover-contained" className="tooltip-popover-section">
      <Popover.Body className="tooltip-popover-body">
        Deducted monthly from your pot.
      </Popover.Body>
    </Popover>
  );
  return (
    // prettier-ignore
    <>
      <a href="#/account" className="text-end">
        <Icons
          iconname="close"
          variant="icon-twenty-four-px"
          clickHandler={props.handleCloseButton}
        />
      </a>
      <Buttons
        className="btn btn-secondary print-hide"
        name="Download charges"
        handleClick={() => generatePDF(targetRef, {filename: 'Charges.pdf'})}
              
            />
      <div className="pot-charge-table"  ref={targetRef}>
        <p className="heading">Charges</p>
        {props.GP3 ? (
          <div>
            <p className="text-color">
              Growth Plan 3 is a cash balance plan.
            </p>
            <p className="text-color">
              1. A management charge is applied each year based on the
              accumulated value (0.70%).
            </p>
            <p className="text-color">
              2. The value invested receives an investment credit each
              year. The minimum investment credit will be at least equal
              to the management expenses charged.
              </p>
            <p className="text-color">
              The below charges information applies to TPT drawdown,
              which is available when you start taking your pension.
            </p>
          </div>
        ) : (
          ""
        )}
        <Row className="mb-4">
          <Col md={8} sm={12}>
            
              Fund management charges and administration charges for your membership <b>{props.potId} {props.potName}</b>.
          </Col>
          <Col md={4} sm={12} className="download-btn">
          &nbsp;
          </Col>
        </Row>
        <Row>
          <Col>
            <LabelText section="pot-details" text={popupBlockerText}/>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-4">
            <Table responsive>
              <thead>
                <tr>
                  <th className="charge-thead th-width">
                    Fund
                    <OverlayTrigger
                      placement="auto"
                      overlay={fundTooltips}
                      flip={true}
                    >
                      <span className="charges-tooltips">
                        <Icons iconname="tool-tip-white" variant="icon-twelve-px" />
                      </span>
                    </OverlayTrigger>
                  </th>
                  <th className="charge-thead">Fund management charge
                    <OverlayTrigger
                      placement="auto"
                      overlay={fundManagementTooltips}
                      flip={true}
                    >
                      <span className="charges-tooltips">
                        <Icons iconname="tool-tip-white" variant="icon-twelve-px" />
                      </span>
                    </OverlayTrigger>
                  </th>
                  <th className="charge-thead">Administration charge
                    <OverlayTrigger
                      placement="auto"
                      overlay={administrationChargeTooltips}
                      flip={true}
                    >
                      <span className="charges-tooltips">
                        <Icons iconname="tool-tip-white" variant="icon-twelve-px" />
                      </span>
                    </OverlayTrigger>
                  </th>
                  <th className="charge-thead-total">Total</th>
                </tr>
              </thead>
              <tbody>
                 {props.GP3 ? <tr className="change-trow-growth"><td>
                         <Buttons
                           name={"Growth Plan 3"}
                           className="Modal"
                           handleClick={() =>
                             openPopup(
                               GP3Fund[0]?.content?.properties.fundFactsheets[0]?.url
                             )
                           }
                         ></Buttons>
                       </td>{" "}
                   <td/><td/><td>0.70%</td></tr> : ""}
                   {props.GP3 ? <tr>
                   <td colSpan={4} className="potcharge-heading-drawdown">Drawdown options</td>
                 </tr> : ""}
                <tr>
                  <td colSpan={4} className="potcharge-heading">Managed for me options</td>
                </tr>
                {props.GP3 ? <>{drawdownFunds.map((item, index) => {
                   const charges = (parseFloat(item?.content?.properties?.fundCharge) + parseFloat(props.adminCharge)).toFixed(2);
                   return (
                     <tr className="change-trow" key={index}>
                       <td>
                         <Buttons
                           name={item?.fundName}
                           className="Modal"
                           handleClick={() =>
                             openPopup(
                               item?.fundFactsheets[0]?.url
                             )
                           }
                         ></Buttons>
                       </td>{" "}
                       <td>{item?.fundCharge}</td>
                       <td>
                         {props.adminCharge > 0 &&
                         item?.fundName !=
                           "Managed Income Fund" &&
                         item?.fundName !=
                           "Future Annuity Income Fund"
                           ? props.adminCharge + "%"
                           : "0" + "%"}
                       </td>
                       <td>
                         {item?.fundName ==
                           "Managed Income Fund" ||
                         item?.fundName ==
                           "Future Annuity Income Fund"
                           ? item?.fundCharge
                          : charges + "%"}
                       </td>
                     </tr>
                   );
	                 })}</>:""}
                {managedForYou.map((item, index) => {
                  const charges = (parseFloat(item?.content?.properties?.fundCharge) + parseFloat(props.adminCharge)).toFixed(2);
                  return(
                    <tr className="change-trow" key={index}>
                  <td><Buttons
                    name={item?.content?.properties?.fundName}
                    className="Modal"
                    handleClick={() => openPopup(item?.content?.properties?.fundFactsheets[0]?.url)}
                  ></Buttons>
                  </td>
                  <td>{item?.content?.properties?.fundCharge}</td>
                  <td>{props.adminCharge?props.adminCharge+"%" :"0" + "%"}</td>
                  <td>{charges + "%"}</td>
                </tr>
                  )
                })}
                <tr>
                  <td colSpan={4} className="potcharge-heading">Self-managed fund options</td>
                </tr>
                {selfManaged.map((item, index) => {
                  const charges = (parseFloat(item?.content?.properties?.fundCharge) + parseFloat(props.adminCharge)).toFixed(2);
                  return(
                    <tr className="change-trow" key={index}>
                  <td><Buttons
                    name={item?.content?.properties?.fundName}
                    className="Modal"
                    handleClick={() => openPopup(item?.content?.properties?.fundFactsheets[0]?.url)}
                  ></Buttons></td>                  <td>{item?.content?.properties?.fundCharge}</td>
                  <td>{props.adminCharge?props.adminCharge+"%" :"0" + "%"}</td>
                  <td>{charges+ "%"}</td>
                </tr>
                  )
                })}
                   {!props.GP3 ? 
	                 <>
                <tr>
                  <td colSpan={4} className="potcharge-heading">Drawdown options</td>
                </tr>
                {drawdownFunds.map((item, index) => {
                  const charges = (parseFloat(item?.fundCharge) + parseFloat(props.adminCharge)).toFixed(2);
                  return (
                    <tr className="change-trow" key={index}>
                      <td>
                        <Buttons
                          name={item?.fundName}
                          className="Modal"
                          handleClick={() =>
                            openPopup(
                              item?.fundFactsheets[0]?.url
                            )
                          }
                        ></Buttons>
                      </td>{" "}
                      <td>{item?.fundCharge}</td>
                      <td>
                        {props.adminCharge > 0 &&
                        item?.fundName !=
                          "Managed Income Fund" &&
                        item?.fundName !=
                          "Future Annuity Income Fund"
                          ? props.adminCharge + "%"
                          : "0" + "%"}
                      </td>
                      <td>
                        {item?.fundName ==
                          "Managed Income Fund" ||
                        item?.fundName ==
                          "Future Annuity Income Fund"
                          ? item?.fundCharge
                          : charges + "%"}
                      </td>
                    </tr>
                  );
                })}</>:""}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
           {props.GP3 ? "" :  <Col md={12}><p>Flexi-access drawdown offers the same fund range, so the charges are identical.</p></Col>}
          <Col md={12}>
            {checkIfPre99FundExists() && <>
              <p className="sub-heading">Pre-99 Ethical Target Date Fund</p>
              <p>The pre-99 ethical Target Date fund management charge varies from 0.29% to 0.32% and the administration charge is 0.20%.</p></> 
              }
            <p className="sub-heading">Fund expenses</p>
            <p>Where a fund also incurs specific fund expenses, these are detailed on the fund factsheets.</p>
            <p className="sub-heading">Transaction costs</p>
            <p>Transaction costs are incurred when buying and selling investments to achieve an investment fund&rsquo;s objectives. They are also included in the unit price of your investment funds. They are reported to TPT by the fund manager each year. We compile and share this information in the Chair&rsquo;s Statement, which you can access here so that you have complete information about the costs of your investments.</p>
            <p className="pot-standerd-txtlink">
            <span className="icon ext-link">
              <Icons iconname="external-link" variant="icon-sixteen-px" />
              </span>
            <Buttons
                name="Chair&rsquo;s statement and value for members"
                handleClick={() => {
                  window.open(
                    "https://www.tpt.org.uk/verity-trustees-limited/",
                  );
                }}
              />
              </p>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PotChargesModal;
